import { Component, Input } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { IntegrationNameKeyPipe } from '@/common/pipes/integration-name-key.pipe';

@Component({
    selector: 'app-external-refs',
    standalone: true,
    imports: [KeyValuePipe, TooltipModule, TranslatePipe, IntegrationNameKeyPipe],
    template: `
        @for (extId of externalRefs | keyvalue; track extId.key) {
            @let integrationName = extId.key | integrationNameKey | translate;
            @let toolTipText = 'tile_int_open_tile_in' | translate: { integrationName };

            <a
                [attr.data-testid]="'external-ref-' + extId.key"
                class="ml-4 text-gray-500!"
                [href]="$any(extId.value).url_"
                target="_blank"
                [pTooltip]="toolTipText"
            >
                <span class="text-[12px]! pi pi-external-link"></span>
            </a>
        }
    `,
})
export class ExternalRefsComponent {
    @Input({ required: true }) externalRefs!: Record<string, unknown>;
}
